<template>
  <div>
    <!-- <editModal :editModal="editModal" :toggleEditModal="toggleEditModal" /> -->
    <addChapter
      :addChapter="addChapter"
      @close-addChapter="toggleadChapter"
      :add_chapter="add_chapter"
      :course_id="course_id"
    />
    <editChapter
      :editChapter="editChapter"
      @close-editChapter="toggleeditChapter"
      :edit_chapter="edit_chapter"
      :chapterId="chapterId"
    />

    <AddTopic
      :AddTopic="AddTopic"
      @close-addTopic="toggleAddTopic"
      :chapter_id="chapter_id"
    />
    <editTopic
      :editTopic="editTopic"
      @close-editTopic="toggleeditTopic"
      :editPopup="editPopup"
      :topicInfo="topicInfo"
    />

    <TopicPreview
      :TopicPreview="TopicPreview"
      @close-topicPreview="toggleTopicPreview"
      :playData="playData"
      :topic_preview="topic_preview"
    />
    <previewAsset
      :previewAsset="previewAsset"
      @close-previewAsses="togglepreviewAsset"
    />
    <PreviewEmbed
      :previewEmbedded="previewEmbed"
      @close-previewAsses="toggleEmbedPreview"
      :urlData="urlData"
    />
    <EditEmbed
      :editEmbed="editEmbed"
      @close-editEmbed="toggleEditEmbed"
      :urlData="urlData"
      :chapter="chapter_id"
    />
    <Liveedit
      :liveedit="liveedit"
      @close-liveedit="toggleliveedit"
      :urlData="urlData"
      :chapter="chapter_id"
    />
    <!-- <b-modal id="add-chapter" okTitle="Save" centered hide-header>
      <p class="font-semibold text-md pb-1">Add chapter</p>
      <base-input
        v-model="name"
        placeholder="Enter Chapter Name"
        class="cust-mb0"
      ></base-input>
      <b-button @click="createChapter(name)" type="primary"
        >Create Chapter</b-button
      >
    </b-modal> -->
    <!-- <b-modal id="edit-chapter" okTitle="Save" centered hide-header>
      <p class="font-semibold text-md pb-1">Chapter Name</p>
      <base-input
        placeholder="Enter Chapter Name"
        class="cust-mb0"
      ></base-input>
    </b-modal> -->
    <!-- <b-modal
      id="add-topic"
      okTitle="Save"
      centered
      hide-header
      class="cust-padding"
    >
      <div class="mb-6">
        <p class="font-semibold text-md pb-1">Topic Name</p>
        <base-input
          placeholder="Enter Topic Name"
          class="cust-mb0"
        ></base-input>
      </div>
      <div class="mb-4">
        <p class="font-semibold text-md pb-1">Upload Files</p>
        <div class="flex">
          <vx-card
            class="shadow-none  bg-f4f5f6 mx-1 hover:bg-white cursor-pointer py-3 rounded-md"
            v-for="(item, index) in chapters"
            :key="'item-' + index"
          >
            <div class="flex justify-center">
              <img :src="item.img" class="w-2/5 " />
            </div>
            <p class="font-semibold text-center text-sm pt-2">
              {{ item.title }}
            </p>
          </vx-card>
        </div>
      </div>
      <div class="mb-6">
        <div class="progress-wrapper">
          <div class="progress rounded-lg mb-0">
            <div
              class="progress-bar bg-default"
              role="progressbar"
              aria-valuenow="60"
              aria-valuemin="0"
              aria-valuemax="100"
              style="width: 60%;"
            ></div>
          </div>
          <div class="progress-info pt-1 mb-0">
            <div class="progress-label">
              <span class="badge badge-pill badge-default">In Progress</span>
            </div>
            <div class="progress-percentage">
              <span class="">60%</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center">
        <div class="flex px-5 py-1 bg-f4f5f6 rounded-full">
          <p class="text-xs font-semibold ">UploadedFileName.pdf</p>
          <feather-icon
            icon="XIcon"
            class=" font-semibold cursor-pointer icon18px ml-5 my-auto"
          ></feather-icon>
        </div>
      </div>
    </b-modal> -->
    <!-- <b-modal
      id="edit-topic"
      okTitle="Save"
      centered
      hide-header
      class="cust-padding"
    >
      <div class="mb-6">
        <p class="font-semibold text-md pb-1">Topic Name</p>
        <base-input
          placeholder="Enter Topic Name"
          class="cust-mb0"
        ></base-input>
      </div>
      <div class="mb-6">
        <p class="font-semibold text-md pb-1">Upload Files</p>
        <div class="flex">
          <vx-card
            class="shadow-none  bg-f4f5f6 mx-1 hover:bg-white cursor-pointer py-3 rounded-md"
            v-for="(item, index) in chapters"
            :key="'item-' + index"
          >
            <div class="flex justify-center">
              <img :src="item.img" class="w-2/5 " />
            </div>
            <p class="font-semibold text-center text-sm pt-2">
              {{ item.title }}
            </p>
          </vx-card>
        </div>
      </div>
      
      <div class="flex justify-center">
        <div class="flex px-5 py-1 bg-f4f5f6 rounded-full">
          <p class="text-xs font-semibold ">UploadedFileName.pdf</p>
          <feather-icon
            icon="XIcon"
            class=" font-semibold cursor-pointer icon18px ml-5 my-auto"
          ></feather-icon>
        </div>
      </div>
    </b-modal> -->
    <!-- <b-modal id="chapterpreview" centered hide-footer class="cust" size="lg">
      <template #modal-title>
        <p class="font-semibold font-normal text-sm">Topic Preview</p>
        <p class="font-semibold pt-1 text-lg text-black">
          Chapter Python Bootcamp From Zero to Hero in Python
        </p>
      </template>
      <iframe
        class="screenht450 w-full -mt-4"
        src="https://www.youtube.com/embed/_uQrJ0TkZlc"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </b-modal> -->
    <b-card class="border-none">
      <div class="mb-10">
        <div
          class="mb-4 flex justify-between"
          v-for="item in courseId"
          :key="item"
        >
          <base-button
            icon
            type="primary"
            @click="handleClick('admin-coursesdetails')"
          >
            <span class="btn-inner--icon"><i class="ni ni-bold-left"></i></span>

            <span class="btn-inner--text">Back</span>
          </base-button>
          <base-button
            outline
            type="primary"
            class="flex items-center custpad5-10 cursor-pointer"
            @click.stop="add_chapter(item)"
          >
            <feather-icon
              icon="PlusIcon"
              class="font-semibold cursor-pointer"
            ></feather-icon>
            Add Chapter
          </base-button>
        </div>

        <!-- <div class="bg-f4f5f6 h-290px p-6 rounded-lg">
          <div class=" flex items-center">
            <div class="w-full pr-4">
              <label class=" col-form-label form-control-label"
                >Add Chapter
              </label>

              <base-input
                placeholder="Enter Add Chapter"
                class="w-full"
              ></base-input>
            </div>

            <feather-icon
              icon="Trash2Icon"
              class="cursor-pointer bg-danger text-white mt-4 rounded-lg pd-6-20px text-primary "
              svgClasses="w-8 h-6"
            ></feather-icon>
          </div>

          <div class="flex justify-center mt-4">
            <div class="flex ">
              <vx-card
                class="shadow-none  bg-f4f5f6 m-2 hover:bg-white cursor-pointer py-3  w-1/4"
                v-for="(item, index) in chapters"
                :key="'item-' + index"
              >
                <div class="flex justify-center">
                  <img :src="item.img" class="w-1/2 " />
                </div>
                <p class="font-semibold text-center text-sm">
                  {{ item.title }}
                </p>
              </vx-card>
            </div>
          </div>

          <div class="flex justify-center mt-6">
            <base-button
              outline
              type="primary"
              class="flex items-center custpad5-10"
            >
              <feather-icon
                icon="PlusIcon"
                class=" font-semibold cursor-pointer"
              ></feather-icon
              >Add Chapter
            </base-button>
          </div>
        </div> -->
        <!-- <div class="bg-white shadow-md  mt-4 p-6 rounded-lg">
          <div class=" flex items-center">
            <div class="w-full pr-2">
              <label class=" col-form-label form-control-label"
                >Add Section
              </label>

              <base-input
                placeholder="Enter Add Section"
                class="w-full"
              ></base-input>
            </div>

            <feather-icon
              icon="ChevronRightIcon"
              class="cursor-pointer bg-danger text-white mt-4 rounded-lg pd-6-20px text-primary "
              svgClasses="w-6 h-6"
            ></feather-icon>
          </div>

          <div class="">
            <label class=" col-form-label form-control-label">Chapters </label>
            <div class=" flex w-full items-start">
              <div class="w-5/6 mr-2">
                <base-input
                  placeholder="Enter Add Section"
                  class="w-full"
                ></base-input>
              </div>
              <div class="rounded-lg flex w-1/6">
                <div class="w-4/6 p-2 bg-primary rounded-l-lg">
                  <p class="text-white font-normal">Add Chapter</p>
                </div>
                <div
                  class="w-2/6 p-2 bg-danger cursor-pointer rounded-r-lg flex items-center justify-center"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    class=" text-white "
                    svgClasses="w-5 h-5"
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-center mt-6">
            <base-button
              outline
              type="primary"
              class="flex items-center custpad5-10"
            >
              <feather-icon
                icon="PlusIcon"
                class=" font-semibold cursor-pointer"
              ></feather-icon
              >Add Chapter
            </base-button>
          </div>
        </div> -->
      </div>
      <!-- <div
        class="rounded-sm border1px mt-2"
        v-for="(item, index) in chapterByCourseId"
        :key="index"
      >
        <div
          class="rounded-t-sm bg-f4f5f6 text-black p-4"
          v-b-toggle.collapse-3
        >
          <div class="flex justify-between " @click="getTopicByChapterId(item._id)">
            <div class="flex my-auto items-center">
              <div class="my-auto">
                <feather-icon
                  icon="ChevronDownIcon"
                  class="font-semibold cursor-pointer icon18px text-black"
                ></feather-icon>
              </div>
              <div class="font-semibold text-md mx-3">
                {{ item.name }}
              </div>
              <div class="text-sm">
                {{item.topic.length}} Topic
              </div>
              <div class="dot-w-5 my-auto mx-2"></div>
              <div class="text-sm">
                25min
              </div>
            </div>
            <div class="flex">
              <base-button
                outline
                type="primary"
                class="btn btn-primary btn-sm flex"
                v-b-modal="'add-topic'"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="font-semibold cursor-pointer icon18px"
                  @click="add_topic(item)"
                ></feather-icon>
                Add Topic
              </base-button>
              <base-button size="sm" type="primary" outline
                ><feather-icon
                  icon="EditIcon"
                  class="font-semibold cursor-pointer icon18px"
                  
                  @click="edit_chapter(item)"
                ></feather-icon
              ></base-button>
              <base-button size="sm" type="danger"
                ><feather-icon
                  icon="Trash2Icon"
                  class="font-semibold cursor-pointer icon18px"
                  @click="deleteChapter(item._id)"
                ></feather-icon
              ></base-button>
            </div>
          </div>
        </div>
        <b-collapse class="" id="collapse-3">
          <div class="flex justify-between px-6 py-3">
            <div class="flex items-center" v-for="(item, index) in topicByChapterId" :key="index">
              
                <div class="my-auto">
                    <a :href="topicFileUrl(item)" target="_blank">
                        <feather-icon
                        v-if="item.docType =='video'"
                        icon="PlayCircleIcon"
                        class="font-semibold cursor-pointer icon18px text-black"
                        >
                      </feather-icon>
                      <feather-icon
                        v-else
                        icon="FileIcon"
                        class="font-semibold cursor-pointer icon18px text-black"
                        >
                      </feather-icon>
                    </a>
                  
                </div>
                
                <div class="text-sm mx-3 my-auto font-medium">
                  {{ item.name }}
                  
                </div> -->
      <!-- <div class="my-auto">
                  <feather-icon
                    icon="ChevronDownIcon"
                    class="font-semibold cursor-pointer icon18px text-black"
                  ></feather-icon>
                </div> -->
      <!-- <div class="dot-w-5 my-auto mr-3"></div>
                <div class="text-sm ">
                  08.15
                </div>
                <div class="flex ml-5">
                  <span
                    class="text-xs cursor-pointer hover:underline "
                    v-b-modal="'chapterpreview'"
                    >Preview</span
                  >
                  <span
                    class="text-xs mx-3 cursor-pointer hover:underline "
                    v-b-modal="'edit-topic'"
                    @click="editPopup(item)"
                    >Edit</span
                  >
                  <span
                    class="text-xs cursor-pointer hover:underline "
                    @click="deletePopup(item._id)"
                    >Delete</span
                  >
                </div>
            </div>
            
          </div> -->
      <!-- <div class="flex justify-between px-6 py-3">
            <div class="flex items-center">
              <div class="my-auto">
                <feather-icon
                  icon="FileIcon"
                  class="font-semibold cursor-pointer icon18px text-black"
                ></feather-icon>
              </div>
              <div class="text-sm mx-3 my-auto font-medium">
                Python Objects and Data Structures Assessment
              </div>
              <div class="dot-w-5 my-auto mr-3"></div>
              <div class="text-sm ">
                14.26
              </div>
            </div>
            <div class="flex">
              <span
                class="text-xs cursor-pointer hover:underline "
                v-b-modal="'chapterpreview'"
                >Preview</span
              >
              <span
                class="text-xs mx-3 cursor-pointer hover:underline "
                v-b-modal="'edit-topic'"
                @click="editModal = true"
                >Edit</span
              >
              <span
                class="text-xs cursor-pointer hover:underline "
                @click="deletePopup"
                >Delete</span
              >
            </div>
          </div> -->
      <!-- </b-collapse>
      </div> -->

      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1 border-none">
          <!-- <b-button block v-b-toggle.accordion-1 >Accordion 1</b-button> -->
          <div
            class="rounded-sm border1px mt-2 p-1"
            v-for="(items, index) in chapterByCourseId"
            :key="index"
            header-tag="header"
            role="tab"
          >
            <div class="rounded-t-sm bg-f4f5f6 text-black p-4" block>
              <div
                class="flex justify-between"
                @click.stop="handleAccordion(items._id, index)"
              >
                <div class="flex my-auto items-center">
                  <div class="my-auto">
                    <feather-icon
                      :icon="
                        isCollapseOpen(index)
                          ? 'ChevronDownIcon'
                          : 'ChevronRightIcon'
                      "
                      class="font-semibold cursor-pointer icon18px text-black"
                    ></feather-icon>
                  </div>
                  <div class="font-semibold text-md mx-3">
                    {{ items.name }}
                  </div>
                  <div class="text-sm">
                    <!-- {{
                      items.embedded.length +
                      items.question.length +
                      topicByChapterId.length

                       items.topic.length +
                        items.embedded.length +
                    }} -->
                    {{ getTopicCount(items) }}
                    Topic
                  </div>
                  <div class="dot-w-5 my-auto mx-2"></div>
                  <div class="text-sm">
                    {{ Math.floor(getTotalTime(items.topic) / 60 / 60) }}h{{
                      Math.floor(getTotalTime(items.topic) / 60) -
                      Math.floor(getTotalTime(items.topic) / 60 / 60) * 60
                    }}m {{ getTotalTime(items.topic) % 60 }}sec
                  </div>
                </div>
                <div class="flex">
                  <base-button
                    outline
                    type="primary"
                    class="btn btn-primary btn-sm flex"
                    v-b-modal="'AddTopic'"
                    @click.stop="add_topic(items)"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="font-semibold cursor-pointer icon18px"
                    ></feather-icon>
                    Add Topic
                  </base-button>
                  <base-button size="sm" type="primary" outline
                    ><feather-icon
                      icon="EditIcon"
                      class="font-semibold cursor-pointer icon18px"
                      v-b-modal="editChapter"
                      @click.stop="edit_chapter(items)"
                    ></feather-icon
                  ></base-button>
                  <base-button size="sm" type="danger"
                    ><feather-icon
                      icon="Trash2Icon"
                      class="font-semibold cursor-pointer icon18px"
                      @click.stop="deleteChapter(items)"
                    ></feather-icon
                  ></base-button>
                </div>
              </div>
            </div>

            <b-collapse
              :id="'accordion-' + index"
              accordion="my-accordion"
              role="tabpanel"
              ref="accordion"
            >
              <b-card-body>
                <!-- <b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text> -->
                <b-card-text>
                  <div class="">
                    <div
                      class="flex items-center px-6 py-3"
                      v-for="(data, index) in topicByChapterId"
                      :key="index"
                    >
                      <div class="my-auto">
                        <feather-icon
                          v-if="data.docType == 'video'"
                          icon="PlayCircleIcon"
                          class="font-semibold icon18px text-black"
                        >
                        </feather-icon>
                        <feather-icon
                          v-else
                          icon="FileIcon"
                          class="font-semibold icon18px text-black"
                        >
                        </feather-icon>
                      </div>

                      <div class="text-sm mx-3 my-auto font-medium">
                        {{ data.name }}
                      </div>
                      <!-- <div class="my-auto">
                  <feather-icon
                    icon="ChevronDownIcon"
                    class="font-semibold cursor-pointer icon18px text-black"
                  ></feather-icon>
                </div> -->
                      <div class="dot-w-5 my-auto mr-3"></div>
                      <div class="text-sm" v-if="data.docType == 'video'">
                        {{ Math.floor(data.duration / 60 / 60) }}h{{
                          Math.floor(data.duration / 60) -
                          Math.floor(data.duration / 60 / 60) * 60
                        }}m{{ data.duration % 60 }}s
                      </div>
                      <div class="flex ml-5">
                        <span
                          class="text-xs cursor-pointer hover:underline"
                          v-b-modal="'TopicPreview'"
                          @click.stop="playData(data)"
                          >Preview</span
                        >
                        <span
                          class="text-xs mx-3 cursor-pointer hover:underline"
                          v-b-modal="'editTopic'"
                          @click.stop="editPopup(data)"
                          >Edit</span
                        >
                        <span
                          class="text-xs cursor-pointer hover:underline"
                          @click.stop="deletePopup(data)"
                          >Delete</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="" v-if="items.question.length != 0">
                    <div class="flex items-center px-6 py-3">
                      <div class="my-auto">
                        <feather-icon
                          icon="FileIcon"
                          class="font-semibold icon18px text-black"
                        >
                        </feather-icon>
                      </div>

                      <div class="text-sm mx-3 my-auto font-medium">
                        Assessment
                      </div>

                      <div class="dot-w-5 my-auto mr-3"></div>
                      <div class="flex ml-5">
                        <span
                          class="text-xs cursor-pointer hover:underline"
                          v-b-modal="'previewAsset'"
                          @click.stop="previewAssess(items)"
                          >Preview</span
                        >
                        <span
                          class="text-xs mx-3 cursor-pointer hover:underline"
                          @click.stop="deleteAsses(items)"
                          >Delete</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="" v-if="items.embedded.length != 0">
                    <div
                      class="flex items-center px-6 py-3"
                      v-for="(urls, index) in items.embedded"
                      :key="index"
                    >
                      <div class="my-auto">
                        <feather-icon
                          icon="GlobeIcon"
                          class="font-semibold icon18px text-black"
                        >
                        </feather-icon>
                      </div>

                      <div class="text-sm mx-3 my-auto font-medium">
                        {{ urls.name }}
                      </div>

                      <div class="dot-w-5 my-auto mr-3"></div>
                      <div class="flex ml-5">
                        <span
                          class="text-xs cursor-pointer hover:underline"
                          v-b-modal="'previewEmbed'"
                          @click="previewEmb(urls)"
                          >Preview</span
                        >
                        <span
                          class="text-xs mx-2 cursor-pointer hover:underline"
                          v-b-modal="'editEmbed'"
                          @click="editEmbedded(urls, items)"
                          >Edit</span
                        >
                        <span
                          class="text-xs cursor-pointer hover:underline"
                          @click="deleteEmb(urls)"
                          >Delete</span
                        >
                      </div>
                    </div>
                  </div>
                  <!-- {{ items }} -->
                  <div class="" v-if="items.live.length != 0">
                    <div
                      class="flex items-center px-6 py-3"
                      v-for="(urls, index) in items.live"
                      :key="index"
                    >
                      <div class="my-auto">
                        <feather-icon
                          icon="GlobeIcon"
                          class="font-semibold icon18px text-black"
                        >
                        </feather-icon>
                      </div>

                      <div class="text-sm mx-3 my-auto font-medium">
                        {{ urls.name }}
                      </div>
                      <div class="text-sm mx-3 my-auto font-medium">
                        {{ urls.url }}
                      </div>
                      <div class="dot-w-5 my-auto mr-3"></div>
                      <div class="flex ml-5">
                        <span
                          class="text-xs cursor-pointer hover:underline"
                          @click.stop="previewEmb(urls)"
                          >Preview</span
                        >

                        <span
                          class="text-xs mx-2 cursor-pointer hover:underline"
                          @click.stop="editlive(urls, items)"
                          >Edit</span
                        >
                        <span
                          class="text-xs cursor-pointer hover:underline"
                          @click="deletelive(urls)"
                          >Delete</span
                        >
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </div>
        </b-card>
      </div>
    </b-card>
  </div>
</template>

<script>
import TopicPreview from "./CustomizePreviewPop.vue";
import editTopic from "./CustomizeEdittopic.vue";
import addChapter from "./CustomizeAddChapterPop.vue";
import editChapter from "./CustomizeEditChapterPop.vue";

import AddTopic from "./CustomizeAddTopicPop.vue";
import editModal from "./CustomizeEdit.vue";
import BaseButton from "../../../../../components/BaseButton.vue";
import Customize from "./Customize.vue";
import { mapState } from "vuex";
import previewAsset from "./PreviewAssets.vue";
import PreviewEmbed from "./EmbedPreview.vue";
import EditEmbed from "./editEmbed.vue";
import Liveedit from "./liveEdit.vue";
import { buildTopicFileUrl } from "@/utils/mediaUrl";
export default {
  components: {
    Customize,
    BaseButton,
    editModal,
    addChapter,
    editChapter,
    AddTopic,
    editTopic,
    TopicPreview,
    previewAsset,
    PreviewEmbed,
    EditEmbed,
    Liveedit,
  },
  data() {
    return {
      editModal: false,
      AddTopic: false,

      addChapter: false,
      editChapter: false,
      editTopic: false,
      TopicPreview: false,
      previewAsset: false,
      previewEmbed: false,
      editEmbe: false,
      liveedit: false,
      urlData: {},
      chapterId: {},
      chapter_id: {},
      courseId: [],
      course_id: "",
      topicInfo: {},
      topic_preview: {},
      name: "",
      assessment: [],
      totaltopic: "",
      chapters: [
        {
          img: require("../img/video.png"),
          title: "Video",
        },
        {
          img: require("../img/doc.png"),
          title: "Document",
        },
        {
          img: require("../img/embed.png"),
          title: "Embedded",
        },
        {
          img: require("../img/assessment.png"),
          title: "Assessment",
        },
        {
          img: require("../img/live.png"),
          title: "Live Event",
        },
      ],
      chapId: "",
      editEmbed: false,
    };
  },
  methods: {
    topicFileUrl(item) {
      return buildTopicFileUrl(item.docPath, this.$imageURL, item.docType);
    },
    getTopicCount(items) {
      let topic =
        items.topic && items.topic.length > 0 ? items.topic.length : 0;
      let embedded =
        items.embedded && items.embedded.length > 0 ? items.embedded.length : 0;
      let question = items.question && items.question.length > 0 ? 1 : 0;

      return topic + embedded + question;
    },
    handleClick(name) {
      this.$store.commit("eLearning/selectedCourse", {});
      this.$router.push({ name: name });
    },

    deleteChapter(chapterData) {
      let topicId = chapterData.topic.map((x) => x._id);
      return new Promise(async (resolve, reject) => {
        try {
          const result = await this.deleteAlert();
          if (result.isConfirmed) {
            let loader = this.$loading();
            const data = await this.$store.dispatch("eLearning/deleteChapter", {
              _id: chapterData._id,
              course: chapterData.course,
              topicId: topicId,
            });

            this.$swal("Deleted!", "Chapter has been deleted.", "success");
            loader.close();
            await this.getChapterByCourseId();
            resolve(data);
          }
        } catch (err) {
          reject(err);
          loader.close();
        }
      });
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",

        text: "You won't be able to revert this!",

        icon: "warning",

        showCancelButton: true,

        confirmButtonColor: "#830c81",

        cancelButtonColor: "#d33",

        confirmButtonText: "Yes, delete it!",
      });
    },
    deletePopup(topicData) {
      this.$swal({
        title: "Are you sure?",

        text: "You won't be able to revert this!",

        icon: "warning",

        showCancelButton: true,

        confirmButtonColor: "#830c81",

        cancelButtonColor: "#d33",

        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value == true) {
          const loader = this.$loading();
          try {
            const { data } = await this.$store.dispatch(
              "eLearning/deleteTopic",
              {
                _id: topicData._id,
                chapter: topicData.chapter,
              }
            );
            // this.$swal("Deleted!", "Your file has been deleted.", "success");
            this.$swal.fire({
              title: "Deleted",
              text: "Your file has been deleted.",
              icon: "success",
              confirmButtonColor: "#830c81",
            });
            // console.log(_id);
            // console.log(data);
            loader.close();
            // this.getTopicByChapterId();
            await this.getTopicByChapterId(this.chapId);
            // this.getTopicByChapterId();
          } catch (err) {
            loader.close();
          }
        }
      });
    },
    // async getChapter() {
    //   const { data } = await this.$store.dispatch("eLearning/getChapter");

    //   this.$store.commit("eLearning/chapter", data);
    //   // console.log(this.topic);

    // },
    async getTopic() {
      const { data } = await this.$store.dispatch("eLearning/getTopic");
      // this.$store.commit("eLearning/topic", data);
      // console.log(this.topics);
    },

    // async editChapter(dataForEdit) {
    //   const { data } = await this.$store.dispatch("eLearning/editChapter");
    // }
    // async getChapterId(_id) {
    //   const {
    //     data
    //   } = await this.$store.dispatch("eLearning/getTopicByChapterId", { _id });
    //   // console.log(data);
    //   this.$store.commit("eLearning/getTopicByChapterId", data);
    //   // console.log(data);
    // },

    handleAccordion(_id, index) {
      this.$store.commit("eLearning/getTopicByChapterId", {});
      this.$refs[`accordion`][index].toggle();
      this.chapId = _id;
      this.getTopicByChapterId(_id);
    },

    async getTopicByChapterId(_id) {
      // console.log(_id);
      if (!_id) {
        return;
      }

      const { data } = await this.$store.dispatch(
        "eLearning/getTopicByChapterId",
        { _id }
      );
      // console.log(data);
      this.$store.commit("eLearning/getTopicByChapterId", data);
      // console.log(data);
      // console.log(_id);
      // console.log(this.chapterByCourseId._id);
    },

    add_topic(data) {
      this.toggleAddTopic(true);
      // console.log(data);
      this.chapter_id = data;
    },
    async toggleAddTopic(val = false) {
      this.AddTopic = val;
      if (!val) {
        await this.getTopicByChapterId(this.chapter_id);
        await this.getChapterByCourseId();
      }
    },

    edit_chapter(data) {
      this.toggleeditChapter(true);
      this.chapterId = data;
    },
    async toggleeditChapter(val = false) {
      this.editChapter = val;

      if (!val) {
        await this.getChapterByCourseId();
      }
    },

    async getChapterByCourseId() {
      await this.$store.dispatch("eLearning/getChapterByCourseId", {
        id: this.selectedCourse._id,
      });
    },

    getCourseId() {
      this.courseId = { _id: this.selectedCourse._id };
      // console.log(this.courseId._id);
    },
    add_chapter(data) {
      this.toggleadChapter(true);
      // console.log(data);
      this.course_id = data;
    },
    async toggleadChapter(val = false) {
      this.addChapter = val;
      if (!val) {
        await this.getChapterByCourseId();
      }
    },
    editPopup(data) {
      this.toggleeditTopic(true);
      this.topicInfo = data;
    },
    async toggleeditTopic(val = false) {
      this.editTopic = val;
      if (!val) {
        this.getTopicByChapterId(this.chapId);
      }
    },
    playData(data) {
      this.topic_preview = { ...data };
      this.toggleTopicPreview(true);
    },
    async toggleTopicPreview(val = false) {
      this.TopicPreview = val;
    },
    async previewAssess(chapter) {
      this.togglepreviewAsset(true);
      const data = await this.$store.dispatch("eLearning/getAssessment", {
        chapter: chapter._id,
      });
    },
    async togglepreviewAsset(val = false) {
      this.previewAsset = val;
    },

    gettotaltopic(val1) {
      val1 = this.topic.lenght + this.embedded.lenght;
      // console.log(val1);
      return val1;
    },
    getTotalTime(data) {
      return data
        .filter((data) => data.docType == "video")
        .map((data) => data.duration)
        .reduce((total, value) => total + parseInt(value), 0);
    },
    deleteAsses(data) {
      let option = [];
      let question = [];
      data.question.forEach((x) => {
        option.push(x.option);
        question.push(x._id);
      });

      return new Promise(async (resolve, reject) => {
        try {
          const result = await this.deleteAlert();
          if (result.isConfirmed) {
            let loader = this.$loading();

            const delete_data = await this.$store.dispatch(
              "eLearning/deleteAssessment",
              {
                questionId: question,
                chapterId: data._id,
                optionId: option,
              }
            );

            this.$swal("Deleted!", "Assessment has been deleted.", "success");
            await this.getChapterByCourseId();
            await this.getTopicByChapterId(this.chapId);
            loader.close();
            resolve(delete_data);
          }
        } catch (err) {
          reject(err);
          loader.close();
        }
      });
    },
    deleteEmb(url) {
      return new Promise(async (resolve, reject) => {
        try {
          const result = await this.deleteAlert();
          if (result.isConfirmed) {
            let loader = this.$loading();

            const delete_data = await this.$store.dispatch(
              "eLearning/deleteEmbedded",
              {
                chapter: url.chapter,
                embedId: url._id,
              }
            );

            this.$swal("Deleted!", "Deleted Successfully!", "success");
            await this.getChapterByCourseId();
            await this.getTopicByChapterId(this.chapId);
            loader.close();
            resolve(delete_data);
          }
        } catch (err) {
          reject(err);
          loader.close();
        }
      });
    },
    previewEmb(url) {
      this.toggleEmbedPreview(true);
      this.urlData = url;
    },
    toggleEmbedPreview(val = false) {
      this.previewEmbed = val;
    },
    editEmbedded(url, chapter) {
      this.chapter_id = chapter;
      this.toggleEditEmbed(true);
      this.urlData = url;
    },
    toggleEditEmbed(val = false) {
      this.editEmbed = val;
    },
    editlive(url, chapter) {
      // console.log(chapter, "chapter id ");
      this.chapter_id = chapter;
      this.toggleliveedit(true);
      this.urlData = url;
    },
    toggleliveedit(val = false) {
      this.liveedit = val;
    },
  },
  mounted() {
    this.getChapterByCourseId();
    this.getCourseId();
    this.getTopic();
  },

  computed: {
    ...mapState("eLearning", ["chapter"]),
    ...mapState("eLearning", ["topic"]),
    ...mapState("eLearning", ["topicByChapterId"]),
    ...mapState("eLearning", ["chapterByCourseId"]),
    ...mapState("eLearning", ["selectedCourse"]),
    isCollapseOpen() {
      return (index) => {
        return (
          this.$refs[`accordion`] &&
          this.$refs[`accordion`][index] &&
          this.$refs[`accordion`][index].show
        );
      };
    },
  },
};
</script>
